export default __webpack_public_path__ + "locales/ro/EmptyView.json?hash=1a8cbe6170fcb5e84bd36e70cd482381";